/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Col, Modal, Row } from 'antd';
// import styles from './style.module.scss';
// import './index.scss'
import styled from 'styled-components';
import ModalCloseIcon from '../../icon';

const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding-bottom: 0px;
  .ant-modal-content {
    background-color: #303843;
    padding: 10px;
  }
  .ant-modal-title {
    color: white;
    margin: 20px;
    font-size: 20px;
  }
  div {
    color: white;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .ant-upload-wrapper {
    margin: 20px;
  }
  .anticon {
    color: white;
  }
  .ant-btn-primary{

    height:40px;
    width:70px;
    
    background: #8CC63E;
    border-radius: 4px;
    margin-right:20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    margin-top:auto;
        margin-bottom:20px
    
    /* White */
    
    color: #FFFFFF;
      }
      .ant-btn-default{
        font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    
    /* White */
    
    color: #FFFFFF;
    
        height:40px;
        width:80px;
        box-shadow: -2px 10px 30px rgba(0, 0, 0, 0.25);
        background: #303843;
        border-radius: 4px;
        margin-right:10px
        margin-top:auto;
        margin-bottom:20px
            
          }
`;
interface DeleteModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
  handleDelete: any;
}
const DeleteModal: React.FC<DeleteModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  handleDelete,
}: DeleteModalProps) => {
  const handleOk = () => {
    handleDelete();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <StyledModal
        destroyOnClose
        okText={'Yes'}
        cancelText={'Cancel'}
        closable={false}
        title="Delete"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        // closeIcon={<ModalCloseIcon/>}
      >
        <p style={{ marginLeft: '20px' }}>
          Are you sure you want to delete this item?
        </p>
      </StyledModal>
    </>
  );
};

export default DeleteModal;
